import React from "react";
import PropTypes from "prop-types";
import ProductPrice from '../../ui/ProductPrice.jsx';
import LikeButton from "../Hearts.jsx";

/**
 * ProductInfo Molecule - Displays price and lovemeter side by side
 * @component
 * @example
 * <ProductInfo
 *   price={99.99}
 *   currency="€"
 *   formatPrice={(p) => p.toFixed(2)}
 *   lovemeter={4.5}
 * />
 */
const ProductInfo = ({
    price,
    currency,
    formatPrice,
    lovemeter,
    className = "",
    isSpecial = false,
    showLovemeter = true,
}) => {
    return (
        <div className={`flex gap-5 justify-between items-center px-2.5 pt-2.5 my-2 ${className}`}>
            <ProductPrice
                price={price}
                currency={currency}
                formatPrice={formatPrice}
                isSpecial={isSpecial}
            />
            {showLovemeter && <LikeButton lovemeter={lovemeter} isSpecial={isSpecial} />}
        </div>
    );
};

ProductInfo.propTypes = {
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    currency: PropTypes.string,
    formatPrice: PropTypes.func,
    lovemeter: PropTypes.number,
    className: PropTypes.string,
    isSpecial: PropTypes.bool,
};

export default ProductInfo;
